import axios from 'axios';
import interceptors from './interceptors';

const baseURL = (() => {
  const url = new URL(location.href);
  return `${url.protocol}//${url.host}/api`;
})();

const instance = axios.create({ baseURL });

const api = interceptors(instance, true);
const http = interceptors(instance, false);

export { api, http };
